export const previousRouteKey = "previousRoute";

export interface SessionRoute {
  route: string;
  isUsed: boolean;
}